import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { usePost } from "seed/api";
import { useSet } from "seed/gql";
import { SET_CHAT } from "seed/gql/queries";
import { useNotifications } from "components/vmisc/notifications/NotificationResolver";
import View from "components/vmisc/notifications/Notifications.view";

const Notifications = forwardRef(({
  flow, 
  isDebug = false,
  onLoadNotifications = () => {},
}, ref) => {

  const [calledUpdate, setCalledUpdate] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const { notifications, refetchNotifications } = useNotifications({ flow, isDebug });
  
  const [callSetRead] = useSet(SET_CHAT);

  const [callResume] = usePost("/executions/resume_execution", {
    onCompleted: () => refetchNotifications(),
  });

  const updatePendingNotifications = (notifications) => {
    notifications.forEach(notification => {
      if(notification.isAwaiting) return;
      notification.group.forEach(execution => {
        callSetRead({
          id: execution.chatMessage.chat.id,
          isRead: true
        });
      });
    });
  }

  const onClickResume = (execution) => {
    callResume({ execution_id: execution.id });
    setSelectedChat(execution.chatMessage.chat);
  }

  
  useImperativeHandle(ref, () => ({
    updatePendingNotifications,
    refetchNotifications: () => refetchNotifications(),
  }));

  useEffect(() => {
    if(calledUpdate) return;
    updatePendingNotifications(notifications);
    setCalledUpdate(true);
  }, [notifications]);

  useEffect(() => {
    onLoadNotifications(notifications);
  }, [notifications, onLoadNotifications]);
  
  return (
    <View
      flow={flow}
      notifications={notifications}
      selectedChat={selectedChat}
      setSelectedChat={setSelectedChat}
      onClickResume={onClickResume}
    />
  );

});

Notifications.displayName = "Notifications";

export default Notifications;